import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const Mail: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4.25A2.75 2.75 0 0 0 2.25 7v10A2.75 2.75 0 0 0 5 19.75h14A2.75 2.75 0 0 0 21.75 17V7A2.75 2.75 0 0 0 19 4.25H5ZM3.75 7c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v.599l-7.557 5.037c-.42.28-.966.28-1.386 0L3.75 7.6V7Zm0 2.401V17c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V9.401l-6.725 4.483a2.75 2.75 0 0 1-3.05 0L3.75 9.401Z"
        fill="#191817"
      />
    </svg>
  );
};

export { Mail };
